import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

export function IconFacebook(props: any) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      tabIndex="-1"
      {...props}>
      <Path
        //@ts-ignore
        tabIndex="-1"
        data-name="Icon awesome-facebook"
        d="M23.999 12.073a12 12 0 10-13.874 11.926v-8.437H7.076v-3.49h3.048V9.413c0-3.026 1.79-4.7 4.532-4.7a18.359 18.359 0 012.686.236v2.97H15.83a1.74 1.74 0 00-1.955 1.885v2.266h3.328l-.532 3.49h-2.8v8.437a12.055 12.055 0 0010.128-11.924z"
        fill="#4167b2"
      />
    </Svg>
  );
}
